import { SortingOptionsType } from '@components/design/migrated/Table';
import { useCallback } from 'react';
import { SaleType } from '@models/OpportunityReview';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';

interface PersistedSortingArgsOpportunityReview {
  tableId: string;
  defaultSorting: SortingOptionsType;
  selectedSaleType: SaleType;
}

export interface PersistedSortingOpportunityReview {
  sorting: SortingOptionsType;
  updateOptions: (options: SortingOptionsType) => void;
}

const usePersistedSortingOpportunityReview = ({
  tableId,
  defaultSorting,
  selectedSaleType,
}: PersistedSortingArgsOpportunityReview): PersistedSortingOpportunityReview => {
  const pagesConfig = usePageConfig();

  const getSortingOptions = () => {
    if (Object.keys(pagesConfig.sortingOptionsOpportunityReview).length === 0) {
      return defaultSorting;
    }
    return pagesConfig.sortingOptionsOpportunityReview;
  };

  const sorting: SortingOptionsType = getSortingOptions();

  if (selectedSaleType === SaleType.VALUE) {
    sorting.headerKey = sorting.headerKey.replace('Volume', 'Revenue');
  } else {
    sorting.headerKey = sorting.headerKey.replace('Revenue', 'Volume');
  }

  const updateOptions = useCallback(
    (options: SortingOptionsType) => {
      pagesConfig.setSortingOptionsOpportunityReview(options);
    },
    [tableId, pagesConfig],
  );

  return { sorting, updateOptions };
};

export default usePersistedSortingOpportunityReview;
